import * as types from "../mutation-types";

const state = {
    adminToolConfig: null,
    assetAllocation: null,
    reportDetailsConfig: null
};

const getters = {
    assetAllocationDataSource(state) {
        return state.adminToolConfig && state.adminToolConfig.dataSource && state.adminToolConfig.dataSource.assetAllocationDataSource;
    },
    resourceLimit(state) {
        return state.adminToolConfig && state.adminToolConfig.resourceLimit;
    },
    securityLimit(state, getters) {
        return getters.resourceLimit && getters.resourceLimit.securityNumber;
    },
    portfolioNumberLimit(state, getters) {
        return getters.resourceLimit && getters.resourceLimit.portfolioNumber;
    },
    languageList(state) {
        return state.adminToolConfig && state.adminToolConfig.languageList;
    },
    currencyList(state) {
        return (state.adminToolConfig && state.adminToolConfig.currencyList) || [];
    },
    colorConfig(state) {
        return state.adminToolConfig && state.adminToolConfig.colors;
    },
    localization(state) {
        return state.adminToolConfig && state.adminToolConfig.localization;
    },
    showCountry(state, getters) {
        return getters.localization && getters.localization.showCountry;
    },
    stateOrProvince(state, getters) {
        return getters.localization && getters.localization.stateOrProvince;
    },
    presetTimePeriodOptions(state, getters) {
        return getters.localization && getters.localization.presetTimePeriod;
    },
    showMFComprehensive(state) {
        return state.adminToolConfig && state.adminToolConfig.showMFComprehensive;
    },
    isApplyEarliestAvailable(state) {
        return state.adminToolConfig && state.adminToolConfig.applyStartDateType === 0;
    },
    isScenarioAnalysisEnabled(state) {
        return state.adminToolConfig && state.adminToolConfig.isScenarioAnalysisEnabled;
    },
    portfolioSettingModules(state, getters) {
        return state.adminToolConfig && state.adminToolConfig.portfolioSettingModules;
    },
    getAdminConfigs(state) {
        return state.adminToolConfig;
    },
    getHypoTypes(state) {
        return state.adminToolConfig && state.adminToolConfig.hypoTypes;
    },
    activeCustomBenchmark(state) {
        return state.adminToolConfig && state.adminToolConfig.dataSource && state.adminToolConfig.dataSource.customBenchmark;
    },
    getUniverses(state) {
        const { universeList = [], universeFields } = state.adminToolConfig || {};
        return universeList.map(item => {
            // eslint-disable-next-line no-unused-vars
            const { UniverseId, ...universeItem } = item;
            const { Type, IsCustomUniverse } = universeItem;
            if (IsCustomUniverse) {
                return universeItem;
            }
            const fields = universeFields[Type] && universeFields[Type].Fields;
            return {
                ...universeItem,
                Fields: fields
            };
        });
    },
    getPCTOptionList(state) {
        return state.adminToolConfig && state.adminToolConfig.optionList;
    },
    getSavedHyposLimit(state) {
        return state.adminToolConfig && state.adminToolConfig.resourceLimit && state.adminToolConfig.resourceLimit.savedFiles;
    }
};

const mutations = {
    [types.SET_ADMIN_TOOL_CONFIG](state, data) {
        state.adminToolConfig = data;
    },
    [types.SET_ASSET_ALLOCATION](state, data) {
        state.assetAllocation = data;
    },
    [types.SET_REPORT_DETAILS_CONFIG](state, data) {
        state.reportDetailsConfig = data;
    }
};

export default {
    state,
    getters,
    mutations
};
